// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table {
  border-collapse: collapse;
  width: 100%;
  overflow: hidden;
  font-size: 16px;
  table-layout: fixed;
  font-weight: 100;
}
.table-head {
  background-color: #f9fafb;
  font-size: 14px;
  color: #475467;
  height: 52px;
  width: 100%;
  text-align: left;
}
.table-head-cell {
  border: 1px solid #eaecf0;
  padding: 0 1rem 0 15px;
}
.table-data-row {
  height: 55px;
}

.table-data-cell {
  border: 1px solid #eaecf0;
  padding: 0 1rem 0 15px;
  white-space: nowrap;
  width: 20%;
}

.table-data-cell__anchor {
    display: flex;
    flex-shrink: 1;
    align-items: center
  }

.table-data-cell__anchor > span {
      display: block;
      max-width: 95%;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
      white-space: nowrap;
    }

.table-data-cell__anchor > div {
      /* this is the Icon */
      flex-shrink: 0;
    }

.SwitchRoot {
  all: unset;
  width: 42px;
  height: 25px;
  background-color: #f2f4f7;
  border-radius: 9999px;
  position: relative;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.SwitchRoot:focus {
  /* box-shadow: 0 0 0 2px red; */
}
.SwitchRoot[data-state='checked'] {
  background-color: #590b8a;
}

.SwitchThumb {
  display: block;
  width: 21px;
  height: 21px;
  background-color: white;
  border-radius: 9999px;
  box-shadow: 0 2px 8px gray;
  transition: transform 100ms;
  transform: translateX(2px);
  will-change: transform;
}
.SwitchThumb[data-state='checked'] {
  transform: translateX(19px);
}

.Label {
  color: white;
  font-size: 15px;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/DataTable.pcss"],"names":[],"mappings":"AASA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,eAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAA4B;EAC5B,eAA6B;EAC7B,cAAgB;EAChB,YAAwB;EACxB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAA6B;EAC7B,sBAAmC;AACrC;AACA;EACE,YAAuB;AACzB;;AAEA;EACE,yBAA6B;EAC7B,sBAAmC;EACnC,mBAAmB;EACnB,UAAU;AAmBZ;;AAlBE;IACE,aAAa;IACb,cAAc;IACd;EAcF;;AAZE;MACE,cAAc;MACd,cAAc;MACd,gBAAgB;MAChB,uBAAuB;MACvB,iBAAiB;MACjB,mBAAmB;IACrB;;AACA;MACE,qBAAqB;MACrB,cAAc;IAChB;;AAIJ;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB","sourcesContent":["$greylight: #f9fafb;\n$greymedium: #eaecf0;\n$greydark: #475467;\n$tableFontSize: 16px;\n$tableHeadFontSize: 14px;\n$tableRowHeight: 55px;\n$tableHeadHeight: 52px;\n$tableLeftPadding: 15px;\n\n.table {\n  border-collapse: collapse;\n  width: 100%;\n  overflow: hidden;\n  font-size: $tableFontSize;\n  table-layout: fixed;\n  font-weight: 100;\n}\n.table-head {\n  background-color: $greylight;\n  font-size: $tableHeadFontSize;\n  color: $greydark;\n  height: $tableHeadHeight;\n  width: 100%;\n  text-align: left;\n}\n.table-head-cell {\n  border: 1px solid $greymedium;\n  padding: 0 1rem 0 $tableLeftPadding;\n}\n.table-data-row {\n  height: $tableRowHeight;\n}\n\n.table-data-cell {\n  border: 1px solid $greymedium;\n  padding: 0 1rem 0 $tableLeftPadding;\n  white-space: nowrap;\n  width: 20%;\n  &__anchor {\n    display: flex;\n    flex-shrink: 1;\n    align-items: center;\n\n    & > span {\n      display: block;\n      max-width: 95%;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-right: 5px;\n      white-space: nowrap;\n    }\n    & > div {\n      /* this is the Icon */\n      flex-shrink: 0;\n    }\n  }\n}\n\n.SwitchRoot {\n  all: unset;\n  width: 42px;\n  height: 25px;\n  background-color: #f2f4f7;\n  border-radius: 9999px;\n  position: relative;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.SwitchRoot:focus {\n  /* box-shadow: 0 0 0 2px red; */\n}\n.SwitchRoot[data-state='checked'] {\n  background-color: #590b8a;\n}\n\n.SwitchThumb {\n  display: block;\n  width: 21px;\n  height: 21px;\n  background-color: white;\n  border-radius: 9999px;\n  box-shadow: 0 2px 8px gray;\n  transition: transform 100ms;\n  transform: translateX(2px);\n  will-change: transform;\n}\n.SwitchThumb[data-state='checked'] {\n  transform: translateX(19px);\n}\n\n.Label {\n  color: white;\n  font-size: 15px;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
